import React, { useEffect, useState } from "react";
import { clinicService } from "../../../services/clinicService";
import { NotificationManager } from "src/util/notify";
import { MaskFormatted } from "../../../helper/mask-helper";
import moment from "moment";
import { useNavigate } from "react-router";
import { AnnouncementServices } from "src/services/announcementService";
import CustomSkeleton from "src/control-components/skeleton/skeleton";
import UpdateCustomerStatus from "../clinic-Actions/change-Customer-Status";
import { getCustomerStatusConfig } from "src/helper/customer-status-config";

function ClinicInfo({ state }) {
  const [clinicInfo, setClinicInfo] = useState(state?.field || {});
  const [loading, setLoading] = useState(false);
  const [isBAAAcknowledged, setIsBAAAcknowledged] = React.useState(undefined);
  const [isOpenCustomerStatus, setIsOpenCustomerStatus] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    getClinicInfo();
  }, []);

  async function getBAAStatus() {
    if(clinicInfo && Object.keys(clinicInfo).length > 0 && clinicInfo?.masterClinicId) {
      const result = await AnnouncementServices.getBAASignedByClinicId({masterClinicId: clinicInfo?.masterClinicId}) 
      if(result && result.status) {
        // setIsBAAAcknowledged(result.resultData)
      }
    }
  };

  useEffect(() => {
    getBAAStatus()
  }, [clinicInfo]);

  const getClinicInfo = async () => {
    setLoading(true);
    await clinicService
      .getClinicInfo(state)
      .then((result) => {
        setLoading(false);
        setClinicInfo((prev) => ({ ...prev, ...result.resultData }));
        setIsBAAAcknowledged(result?.resultData?.isBaaAcknowledged);
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error);
      });
  };
  const refreshClinicInfo = async () => {
    setLoading(true);
    await clinicService
      .getAllClinic({
        region: null,
        isActive: true,
        state: null,
        isRCM: null,
        customerStatusId: null,
      })
      .then((result) => {
        const updated = result.resultData?.find((c) => c.id === state?.field?.id);
        if (updated) {
          setClinicInfo((prev) => ({ ...prev, ...updated }));
        }
      })
      .catch((error) => {
        NotificationManager.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <>
      <div className="custom-card bg-white border-0 shadow-sm rounded-4 p-4 position-relative">

        <div className="d-flex justify-content-start">
          <button
            className="btn btn-link text-decoration-none p-0 mb-3"
            onClick={() => navigate(-1)}
          >
            <i className="fas fa-arrow-left fs-5 text-secondary"></i>
          </button>
        </div>
        <div className="text-center mb-4">
          <h4 className="fw-bold text-dark mb-2">
            {clinicInfo?.clinicName}
          </h4>

          {isBAAAcknowledged === undefined && (
            <CustomSkeleton shape="text" />
          )}

          {isBAAAcknowledged === true && (
            <span className="badge bg-success-subtle text-success border border-success-subtle px-3 py-2 rounded-pill">
              BAA Acknowledged
            </span>
          )}

          {isBAAAcknowledged === false && (
            <span className="badge bg-danger-subtle text-danger border border-danger-subtle px-3 py-2 rounded-pill">
              BAA Not Acknowledged
            </span>
          )}
        </div>
        <div className="d-flex justify-content-center align-items-center gap-2 mb-3">

          {loading ? (
            <div style={{ width: "100px" }}>
              <CustomSkeleton shape="text" />
            </div>
          ) : (
            <div
              className="d-inline-flex align-items-center gap-2 px-3 py-2 rounded-pill border"
              style={{
                background: getCustomerStatusConfig(
                  clinicInfo?.customerStatusName
                )?.bg,
                borderColor: getCustomerStatusConfig(
                  clinicInfo?.customerStatusName
                )?.border,
              }}
            >
              <i
                className={
                  getCustomerStatusConfig(
                    clinicInfo?.customerStatusName
                  )?.icon
                }
                style={{
                  color:
                    getCustomerStatusConfig(
                      clinicInfo?.customerStatusName
                    )?.color,
                  fontSize: "11px",
                }}
              />

              <span
                className="fw-semibold"
                style={{
                  color:
                    getCustomerStatusConfig(
                      clinicInfo?.customerStatusName
                    )?.color,
                  fontSize: "12px",
                }}
              >
                {clinicInfo?.customerStatusName || "N/A"}
              </span>
            </div>
          )}

          <span
            className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-green"
            style={{
              cursor: "pointer",
            }}
            onClick={() =>
              setIsOpenCustomerStatus(true)
            }
            title="Edit Customer Status"
          >
            <div className="k-chip-content">
              <i className="fas fa-edit"></i>
            </div>
          </span>
        </div>

        <div className="text-center mb-3">
          <p className="mb-1 text-dark fw-medium">
            {clinicInfo?.address}
          </p>

          <p className="mb-0 text-muted">
            {clinicInfo?.city}, {clinicInfo?.state}
            {clinicInfo?.zip && (
              <>
                {" "}
                •{" "}
                {clinicInfo.zip.length !== 9
                  ? clinicInfo.zip
                  : `${clinicInfo.zip.substring(
                    0,
                    5
                  )}-${clinicInfo.zip.substring(5)}`}
              </>
            )}
          </p>
        </div>
        <div className="d-flex flex-column gap-2 mb-3">

          <div className="d-flex justify-content-center align-items-center gap-2 text-muted">
            <i className="fa fa-phone"></i>

            <span className="fw-medium text-dark">
              {MaskFormatted(
                clinicInfo?.phone,
                "(999) 999-9999"
              )}
            </span>
          </div>

          <div className="d-flex justify-content-center align-items-center gap-2 text-muted">
            <i className="fa fa-envelope"></i>

            <span className="fw-medium text-dark">
              {clinicInfo?.email}
            </span>
          </div>
        </div>

        <div className="border rounded-4 p-2 bg-light-subtle mb-3">

          <div className="d-flex justify-content-between align-items-center mb-3">

            <span className="fw-semibold text-dark">
              User Seats
            </span>

            <span className="badge bg-primary-subtle text-primary rounded-pill px-3 py-2">
              Total Overview
            </span>
          </div>

          <div className="row g-3 text-center">

            <div className="col-4">
              <div className="bg-white border rounded-4 py-3 shadow-sm h-100">
                <div className="text-muted small mb-1">
                  Used
                </div>

                <div className="fw-bold text-danger fs-6">
                  {clinicInfo?.activeStaffCount ?? 0}
                </div>
              </div>
            </div>

            <div className="col-4">
              <div className="bg-white border rounded-4 py-3 shadow-sm h-100">
                <div className="text-muted small mb-1">
                  Current
                </div>

                <div className="fw-bold text-primary fs-5">
                  {clinicInfo?.maxAllowedUserSeats ?? 0}
                </div>
              </div>
            </div>

            <div className="col-4">
              <div className="bg-white border rounded-4 py-3 shadow-sm h-100">
                <div className="text-muted small mb-1">
                  Initial
                </div>

                <div className="fw-bold text-success fs-5">
                  {clinicInfo?.startingUserCounts ?? 0}
                </div>
              </div>
            </div>

          </div>
        </div>
        <div className="d-flex flex-column gap-2">

          <div className="d-flex justify-content-between border-bottom pb-1">
            <span className="text-secondary">
              Join Date
            </span>

            <span className="fw-semibold text-dark">
              {clinicInfo?.utcDateCreated
                ? moment(
                  clinicInfo?.utcDateCreated
                ).format("MM/DD/YYYY")
                : "N/A"}
            </span>
          </div>

          <div className="d-flex justify-content-between border-bottom pb-1">
            <span className="text-secondary">
              Last Login
            </span>

            <span className="fw-semibold text-dark">
              {clinicInfo?.utcLastLogin
                ? moment(
                  clinicInfo?.utcLastLogin
                ).format("MM/DD/YYYY")
                : "N/A"}
            </span>
          </div>

          <div className="d-flex justify-content-between border-bottom pb-1">
            <span className="text-secondary">
              NPI
            </span>

            <span className="fw-semibold text-dark">
              {clinicInfo?.npi || "N/A"}
            </span>
          </div>

          <div className="d-flex justify-content-between border-bottom pb-1">
            <span className="text-secondary">
              Tax ID
            </span>

            <span className="fw-semibold text-dark">
              {clinicInfo?.taxId || "N/A"}
            </span>
          </div>

          <div className="d-flex justify-content-between border-bottom pb-1">
            <span className="text-secondary">
              Last Doc
            </span>

            <span className="fw-semibold text-dark">
              {clinicInfo?.utcDateLastDocumentCreated
                ? moment(
                  clinicInfo?.utcDateLastDocumentCreated
                ).format("MM/DD/YYYY")
                : "N/A"}
            </span>
          </div>

          <div className="d-flex justify-content-between">
            <span className="text-secondary">
              Taxonomy
            </span>

            <span className="fw-semibold text-dark">
              {clinicInfo?.taxnomy || "N/A"}
            </span>
          </div>

        </div>
      </div>

      {isOpenCustomerStatus && (
        <UpdateCustomerStatus
          clinicIds={[state?.field?.id]}
          onClose={() => setIsOpenCustomerStatus(false)}
          onClear={() => setIsOpenCustomerStatus(false)}
          getAllClinic={refreshClinicInfo}
          currentCustomerStatus={{
            id: clinicInfo?.customerStatusId,
            statusName: clinicInfo?.customerStatusName,
          }}
        />
      )}
    </>
  );
}

export default ClinicInfo;
